<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    inboxId: {
      type: Number,
      default: null,
    },
  },
  emits: ['replace', 'hasResults'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    filteredCannedMessages() {
      if (!this.inboxId) {
        return [];
      }
      return this.cannedMessages.filter(cannedMessage => {
        if (!cannedMessage.inboxes || cannedMessage.inboxes.length === 0) {
          return true;
        }
        return cannedMessage.inboxes.some(inbox => inbox.id === this.inboxId);
      });
    },
    items() {
      return this.filteredCannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        subject: cannedMessage.subject || '',
        files: cannedMessage.files || [],
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
    items: {
      handler(newItems) {
        this.$emit('hasResults', newItems.length > 0);
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    this.$emit('hasResults', false);
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description, {
        subject: item.subject || '',
        files: item.files || [],
      });
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    max-height-class="max-h-[22rem]"
    @mention-select="handleMentionClick"
  />
</template>
